var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [[_c("el-table", {
    staticStyle: {
      width: "100%",
      "margin-top": "20px"
    },
    attrs: {
      data: _vm.tableInfo,
      border: "",
      "row-key": "authorityId",
      stripe: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "邮件ID",
      "min-width": "180",
      prop: "email_id"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "邮件类型",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", {
          class: [scope.row.email_type == "2" ? "serClass" : "perClass"],
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, [_vm._v(" " + _vm._s(scope.row.email_type == "2" ? "单服邮件" : "个人邮件") + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "邮件状态",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", {
          class: [_vm.classStatus[scope.row.email_state]],
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, [_c("el-tag", {
          attrs: {
            size: "medium"
          }
        }, [_vm._v(" " + _vm._s(_vm.emailStatus[scope.row.email_state]) + " ")])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "申请人名称",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.UserInfoList[scope.row.apply_id]) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "邮件申请时间",
      "min-width": "180",
      prop: "apply_date"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "审批人名称",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.email_state == "1" ? "-" : _vm.UserInfoList[scope.row.approve_id]) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "审批时间",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.email_state == "1" ? "-" : scope.row.approve_date) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "审批原因",
      "min-width": "180",
      prop: "reason"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.email_state == "1" ? "-" : scope.row.reason) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "发送时间",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.email_state == "4" || scope.row.email_state == "5" ? scope.row.send_date : "-") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      fixed: "right",
      label: "操作",
      width: "260"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            icon: "el-icon-edit",
            size: "small",
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.checkEmailBtn(scope.row);
            }
          }
        }, [_vm._v(" 查看 ")]), _c("el-button", {
          attrs: {
            disabled: scope.row.email_state === 2 ? false : true,
            icon: "el-icon-edit",
            size: "small",
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.EditEmailBtn(scope.row);
            }
          }
        }, [_vm._v(" 编辑 ")])];
      }
    }])
  })], 1)], _c("div", [_vm.if_dialogFormVisible ? _c("el-dialog", {
    attrs: {
      title: "查看详细邮件信息",
      visible: _vm.dialogFormVisible,
      center: ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogFormVisible = $event;
      }
    }
  }, [_c("show-email-msg", {
    staticStyle: {
      height: "500px",
      "overflow-y": "auto"
    },
    attrs: {
      formData: _vm.formData,
      openEmailType: _vm.openEmailType
    }
  })], 1) : _vm._e()], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };